import { AssetTableSkeleton } from '../Dashboard/AssetTableSkeleton';
import { BreakdownRowWrapper } from '../Dashboard/DemoDashboard/SessionBreakdownTables/BreakdownRowWrapper';
import {
  ShowAllButton,
  TableEmptyState,
  TableErrorState,
} from '../Dashboard/SessionBreakdownComponents';
import { NoResultsState } from '../Dashboard/SessionBreakdownComponents/NoResultsState';
import { FixedTable, type FixedTableProps } from '../FixedTable';

type SessionsBreakdownTableProps<T extends Record<string, any>> = {
  showAll: boolean;
  setShowAll: (showAll: boolean) => void;
  totalSize: number;
  noResults: boolean;
  onClear: () => void;
} & Omit<
  FixedTableProps<T>,
  | 'loader'
  | 'loaderPlaceholderSpace'
  | 'infiniteListMaxHeight'
  | 'sideSpacing'
  | 'rowWrapper'
>;

export const SessionsBreakdownTable = <T extends Record<string, any>>({
  showAll,
  totalSize,
  noResults,
  onClear,
  error,
  isLoading,
  isLoadingBatch,
  data,
  handleFetchNextBatch,
  setShowAll,
  ...rest
}: SessionsBreakdownTableProps<T>) => {
  return (
    <div className="h-[540px] flex flex-col">
      {error ? (
        <TableErrorState />
      ) : data?.length || isLoading ? (
        <>
          <FixedTable<T>
            {...rest}
            isLoading={isLoading}
            isLoadingBatch={isLoadingBatch}
            error={error}
            data={showAll ? data : data?.slice(0, 7)}
            rowWrapper={BreakdownRowWrapper}
            handleFetchNextBatch={handleFetchNextBatch}
            loader={<AssetTableSkeleton rows={7} />}
            loaderPlaceholderSpace={!showAll ? 0 : undefined}
            infiniteListMaxHeight={showAll ? 500 : undefined}
            sideSpacing
          />
          {!isLoading && !showAll && totalSize > 7 && (
            <ShowAllButton
              setShowAll={setShowAll}
              itemsCount={totalSize - 7}
            />
          )}
        </>
      ) : noResults ? (
        <NoResultsState onClear={onClear} />
      ) : (
        <TableEmptyState />
      )}
    </div>
  );
};
